import { render, staticRenderFns } from "./input-datetime.vue?vue&type=template&id=3afc44f0&scoped=true"
import script from "./input-datetime.ts?vue&type=script&lang=ts&external"
export * from "./input-datetime.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc44f0",
  null
  
)

export default component.exports